import CampainTitleCard from './campaignTitleCard.component';

export default CampainTitleCard;